import { differenceInCalendarDays, format } from 'date-fns';
import { useMemo } from 'react';
import { useNow } from '~/components/Util';

export type OpenDayType = { day: string; hours: string; minutes: string };

export const useOpenDay = (value: Date): OpenDayType => {
  const now = useNow();
  return useMemo(() => {
    const diffDays = differenceInCalendarDays(value, now);
    const [hours, minutes] = format(value, 'HH:mm').split(':');

    switch (diffDays) {
      case 0:
        return { day: 'Today', hours, minutes };
      case 1:
        return { day: 'Tomorrow', hours, minutes };
      default:
        return {
          day: format(value, 'MM.dd'),
          hours,
          minutes,
        };
    }
  }, [value, now]);
};
